import { Address } from '@weave/schema-gen-ts/dist/schemas/messaging/settings/v1/settings.pb';
import { SalesforceAccount } from '@weave/schema-gen-ts/dist/schemas/salesforce/v1/salesforce.pb';
import { titleCase } from '@frontend/string';

const buildAddress = (parts: (string | undefined)[]): string => {
  return parts.filter(Boolean).join(', ');
};

export const buildMapsUrl = (query: string): string => {
  const trimmed = query?.trim();
  if (!trimmed) return '';

  // Keep `+` as the word separator but encode all other reserved characters.
  const normalized = trimmed.split(/\s+/).join(' ');
  const encodedQuery = encodeURIComponent(normalized).replace(/%20/g, '+');
  return `https://www.google.com/maps/place/${encodedQuery}`;
};

export const buildAddressFromSalesforce = (account?: SalesforceAccount): string => {
  const street = account?.shippingStreet ? titleCase(account.shippingStreet) : undefined;
  const city = account?.shippingCity ? titleCase(account.shippingCity) : undefined;
  const state =
    account?.shippingStateCode?.toUpperCase() ||
    (account?.shippingState ? titleCase(account.shippingState) : undefined);
  const zip = account?.shippingPostalCode;
  const cityStateZip = [city, state ? `${state}${zip ? ` ${zip}` : ''}` : zip].filter(Boolean).join(', ');
  return buildAddress([street, cityStateZip]);
};

export const buildAddressFromBrandSettings = (addr: Address | undefined): string => {
  const streetAddress = addr?.address?.trim();
  const streetAddress2 = addr?.address2?.trim();
  const city = addr?.city?.trim();
  const state = addr?.state?.trim();
  const zip = addr?.zipCode?.trim();

  const cityStateZip = [city, state ? `${state}${zip ? ` ${zip}` : ''}` : zip].filter(Boolean).join(', ');
  return buildAddress([streetAddress, streetAddress2, cityStateZip]);
};
